var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"main"},[(_vm.showNav)?_c('navigation'):_vm._e(),_c('v-main',[(_vm.showContent)?_c('router-view'):_c('loading')],1),_c('dashFooter'),_c('snackBar'),_c('announcement'),_c('view-event')],1)}
var staticRenderFns = []

export { render, staticRenderFns }